import Conditional from '@next-app/components/Conditional';
import { isNotNullOrUndefined } from '@next-app/utils/common-utils';
import { FC, ReactNode } from 'react';

interface LLAlertProps {
  children: ReactNode;
  type: 'danger' | 'info' | 'success' | 'warning';
  icon?: ReactNode;
  customClass?: string;
}
const LLAlert: FC<LLAlertProps> = ({
  children,
  type,
  icon,
  customClass = '',
}) => {
  return (
    <div
      className={`alert alert-${type} align-items-center mb-ll-3 ${customClass} ${icon ? 'd-flex' : ''}`}
      role="alert"
    >
      <Conditional if={isNotNullOrUndefined(icon)}>
        <>{icon}</>
      </Conditional>
      {children}
    </div>
  );
};

export default LLAlert;
